<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {Icon} from '@iconify/vue';
import {useSettingsStore} from '@/stores/settings.ts';
import {ConversionMode} from '@/generated';
import ConvertButton from "@/components/ConvertButton.vue";
import {useMusicUploadStore} from "@/stores/useMusicUploadStore.ts";

const settingsStore = useSettingsStore();
const {mode} = storeToRefs(settingsStore);
const {isHavingGriffschriftResult} = storeToRefs(useMusicUploadStore());

const modeOptions = [
  {val: 'global' as ConversionMode, label: 'Global', desc: 'Alle Takte gleich', icon: 'fa6-solid:globe'},
  {val: 'auto' as ConversionMode, label: 'Automatisch', desc: 'Beste Qualität', icon: 'fa6-solid:wand-magic-sparkles'},
  {val: 'per_measure' as ConversionMode, label: 'Pro Takt', desc: 'Manuell', icon: 'fa6-solid:sliders'},
];

</script>

<template>
  <div class="animate-rotate-x animate-once glass-panel max-w-screen w-full mx-auto">
    <!-- Mode selector -->
    <div class="border-b border-gray-100 p-1 md:p-4 ">
      <p class=" text-xs font-semibold uppercase tracking-wider text-gray-500">Konvertierungsmodus</p>
      <div class="flex flex-wrap  max-w-full  items-center py-2 gap-1 ">
        <div
            v-for="option in modeOptions"
            :key="option.val"
            @click="mode=option.val"
            class="basis-1/3 inline-flex grow-1 p-2  w-auto min-h-max flex-auto min-w-fit cursor-pointer md:max-w-48 flex-col items-center gap-1 rounded-xl border text-center transition-all duration-200 m-0"
            :class="mode === option.val
            ? 'border-blue-200 bg-blue-50 ring-1 ring-blue-200'
            : 'border-gray-200 bg-white hover:border-blue-200 hover:bg-blue-50/40'"
        >
          <input type="radio" name="convert-mode" :value="option.val" class="sr-only" v-model="mode"/>
          <Icon
              :icon="option.icon"
              class="text-base transition-colors"
              :class="mode === option.val ? 'text-blue-600' : 'text-gray-400'"
          />
          <span class="text-xs font-semibold" :class="mode === option.val ? 'text-blue-700' : 'text-gray-700'">
            {{ option.label }}
          </span>
          <span class="text-[10px] leading-tight text-gray-400">{{ option.desc }}</span>
          <Icon v-if="mode === option.val" icon="fa6-solid:circle-check" class="absolute right-2 top-2 text-[10px] text-blue-500"/>
        </div>
        <ConvertButton v-show="isHavingGriffschriftResult"/>
      </div>
    </div>

  </div>
</template>
